function  getValidFileName(file) {
    let extention = file.name.split('.').pop();
    let tmp_file_name = file.name;
    tmp_file_name = tmp_file_name.replace(extention, "");
    tmp_file_name = tmp_file_name.replace(/[^a-z0-9]/ig, ''); // remove all not valid chars for api
    return new File([file], tmp_file_name + "." + extention, {type: file.type}); // create new file without invalid chars (with spaces the download function will not work)

}
export default getValidFileName;